module.exports = __webpack_public_path__ + "static/media/schools_gray.e2b906c7.svg";